import { createAction } from '@reduxjs/toolkit';

export const deleteButtonClicked = createAction<void>(
  'creativeHub/shared-links-remover/deleteButtonClicked',
);
export const modalOpenedUiEvent = createAction<void>(
  'creativeHub/shared-links-remover/modalOpenedUiEvent',
);
export const modalOpened = createAction<{
  shareIDs: string[];
}>('creativeHub/shared-links-remover/modalOpened');
export const modalClosed = createAction<void>('creativeHub/shared-links-remover/modalClosed');
export const modalCloseUiEvent = createAction<void>(
  'creativeHub/shared-links-remover/modalCloseUiEvent',
);
export const deleteStarted = createAction<{ shareIDs: string[]; bulkJobID: string | null }>(
  'creativeHub/shared-links-remover/deleteStarted',
);
export const deleteSuccess = createAction<{
  result: any;
  shareIDs: string[];
  bulkJobID: string | null;
}>('creativeHub/shared-links-remover/deleteSuccess');
export const deleteError = createAction<{
  error: any;
  shareIDs: string[];
  bulkJobID: string | null;
}>('creativeHub/shared-links-remover/deleteError');
